import type { StateService } from "@uirouter/angularjs";
import type { IWindowService } from "angular";

import { DefaultActions } from "App/Modules/Gui/Components/ActionMenu/DefaultActions";
import type { IAction } from "App/Modules/Gui/Components/ActionMenu/IAction";
import type { IEquipmentFunctionalityTypeSlim, IResponseWithLoading } from "App/Modules/Models";
import { EquipmentFunctionalityClass } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export default class BasicInformationComponentController {
    public static $inject: string[] = ["$state", "$window", "mmModalService"];

    public equipmentFunctionalityType: IResponseWithLoading<IEquipmentFunctionalityTypeSlim>;

    public actions: IAction[];

    private readonly defaultProcessingName = "Irisity Mindview Processing";

    constructor(
        private readonly stateService: StateService,
        private readonly $window: IWindowService,
        private readonly modalService: IModalService,
    ) {
        this.actions = [
            {
                ...DefaultActions.EditAction,
                click: this.editBasicInformation.bind(this),
                isDisabled: () => !this.isEditingEnabled(),
                isLoading: () => this.equipmentFunctionalityType.isLoading,
                isTooltipHidden: this.isEditingEnabled.bind(this),
                tooltip: () => "Validation.EquipmentFunctionalityType.EditDefaultProcessing",
            },
        ];
    }

    public editBasicInformation() {
        this.modalService
            .open<IEquipmentFunctionalityTypeSlim, void>(
                "irEditFunctionalityTypeInformation",
                this.equipmentFunctionalityType.data,
            )
            .subscribe(
                (editResponse) => {
                    if (editResponse) {
                        this.equipmentFunctionalityType.data = editResponse;
                    } else {
                        this.$window.history.go(-1);
                    }
                },
                (reason) => reason,
            );
    }

    public isEditingEnabled() {
        return (
            !this.equipmentFunctionalityType.isLoading &&
            (this.equipmentFunctionalityType.data.class !== EquipmentFunctionalityClass.Processing ||
                this.equipmentFunctionalityType.data.model !== this.defaultProcessingName)
        );
    }
}
